// extracted by mini-css-extract-plugin
export default {"Container":"styles_Container__n0FMO","section-1":"styles_section-1__RGZgZ","content":"styles_content__LjYZ3","section-2":"styles_section-2__qXlUd"};